// components/layout/UserDropdown.tsx
"use client";

import {
  User,
  Settings,
  LogOut,
  HelpCircle,
  Shield,
} from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";

export function UserDropdown() {
  return (
    <Popover>
      <PopoverTrigger
        className={cn(
          "relative inline-flex items-center justify-center h-9 w-9 rounded-full p-0",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/30"
        )}
        aria-label="منوی کاربر"
      >
        <Avatar className="h-9 w-9 border-2 border-primary/20">
          <AvatarFallback className="bg-primary/10 text-primary text-sm font-bold">
            م
          </AvatarFallback>
        </Avatar>
      </PopoverTrigger>

      <PopoverContent
        align="end"
        className="w-64 p-0 bg-card border border-border/60 shadow-[0_12px_32px_-8px_rgba(8,60,32,0.15)] rounded-xl z-50 overflow-hidden"
        sideOffset={8}
      >
        <div className="flex items-center gap-3 p-4 border-b border-border/60 bg-primary/5">
          <Avatar className="h-11 w-11 border-2 border-primary/20">
            <AvatarFallback className="bg-primary/10 text-primary font-bold">
              م
            </AvatarFallback>
          </Avatar>
          <div className="min-w-0">
            <p className="text-sm font-bold truncate text-foreground">
              مدیر کل
            </p>
            <p className="text-xs text-muted-foreground truncate">
              admin@darino.com
            </p>
          </div>
        </div>

        <div className="p-2 bg-card">
          <MenuItem icon={User} label="پروفایل من" />
          <MenuItem icon={Settings} label="تنظیمات" />
          <MenuItem icon={Shield} label="امنیت" />
          <MenuItem icon={HelpCircle} label="راهنما" />
        </div>

        <Separator />

        <div className="p-2 bg-card">
          <button className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium text-destructive hover:bg-destructive/10 transition-colors">
            <LogOut className="h-4 w-4" />
            خروج از حساب
          </button>
        </div>
      </PopoverContent>
    </Popover>
  );
}

function MenuItem({ icon: Icon, label }: { icon: any; label: string }) {
  return (
    <button className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium text-foreground hover:bg-brand-50/60 hover:text-primary transition-colors">
      <Icon className="h-4 w-4 text-muted-foreground" />
      {label}
    </button>
  );
}